import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "clientId", "isDisabled", "onClick", "onDoubleClick"];
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef, useCallback } from "react";
import { useFocusMode } from "../../focusMode";
import { BannerActionStyled } from "../styled/BannerActionStyled";
export var BannerAction = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    clientId = _ref.clientId,
    isDisabled = _ref.isDisabled,
    providedOnClick = _ref.onClick,
    providedOnDoubleClick = _ref.onDoubleClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var onClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnClick) {
      providedOnClick(e);
    }
  }, [isDisabled, providedOnClick]);
  var onDoubleClick = useCallback(function (e) {
    if (isDisabled) {
      e.preventDefault();
      return;
    }
    if (providedOnDoubleClick) {
      providedOnDoubleClick(e);
    }
  }, [isDisabled, providedOnDoubleClick]);
  var _useFocusMode = useFocusMode(),
    focusMode = _useFocusMode.focusMode;
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(BannerActionStyled, _extends({
    focusMode: focusMode,
    tabIndex: 0,
    "aria-disabled": isDisabled,
    onClick: onClick,
    onDoubleClick: onDoubleClick,
    themeMode: themeMode,
    type: "button",
    "data-client-id": clientId
  }, rest, {
    ref: ref
  }), children);
});
BannerAction.displayName = "BannerAction";
//# sourceMappingURL=BannerAction.js.map